import * as Yup from 'yup';
import { PqrClosing } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrClosing = {
    observation: '',
    complianceTerms: '',
    nonComplianceReason: '',
    compensation: false,
    auditObservations: '',
    audit: false,
    emailNotification: false,
    typeCompensation: '',
    manualSendToSfcIfAudit: true,
};

export const validationSchema = (isSample?: boolean) =>
    Yup.object({
        auditObservations: Yup.string().when({
            is: () => Boolean(isSample),
            then: (schema) =>
                schema.required(
                    'Las observaciones de la auditoría son obligatorias'
                ),
        }),
    });
